/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import PropTypes, { func, object } from 'prop-types';

// Material UI
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';

// GA Tagging
import { trackEvent as track } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

// Checkout UI
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import GiftMessageMultiTextBox from './GiftMessageMultiTextBox';
import GiftMessageTextBox from './GiftMessageTextBox';
import RadioButton from '../Partials/RadioButton/RadioButton';

const styles = (theme) => ({
    cardHeaderWrap: {
        borderBottom: `1px solid ${theme.palette.grey5}`,
    },
    cardHeaderRoot: {
        padding: '12px',
    },
    cardHeaderTitle: {
        fontSize: '15px',
        fontWeight: '600',
    },
    closeLink: {
        fontWeight: '600',
        fontSize: '18px',
    },
    divFullRow: {
        width: '100%',
        boxSizing: 'border-box',
        marginBottom: '9px',
    },
    address2LinkRow: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '14px',
    },
    address2Link: {
        color: '#00e',
        textDecoration: 'underline',
    },
    scrollStyle: {
        overflow: 'inherit',
    },
    stateField: {
        paddingTop: '7px',
    },
    countryField: {
        paddingTop: '8px',
    },
    overflowstyle: {
        padding: '6px',
        height: '94%',
    },
    CardHeaderWrap: {
        borderBottom: `1px solid ${theme.palette.grey5}`,
    },
    CardHeaderRoot: {
        padding: '12px',
    },
    CardHeaderTitle: {
        fontSize: '15px',
        fontWeight: '600',
    },
    CloseLink: {
        fontWeight: '600',
        fontSize: '18px',
    },
    cardContentPadding: {
        padding: '0px',
        marginBottom: '20px',
    },
    contPadding: {
        padding: '6px 14px',
    },
    GMRadioLabel: {
        fontSize: '15px',
        color: theme.palette.black,
        fontWeight: '600',
        display: 'inline-block',
    },
    DivFullRow: {
        width: '100%',
        boxSizing: 'border-box',
        marginBottom: '9px',
    },
    Address2LinkRow: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '14px',
    },
    Address2Link: {
        color: '#00e',
        textDecoration: 'underline',
    },
    CheckboxLabel: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '15px',
        fontWeight: '600',
        position: 'relative',
        top: '2px',
    },
    Checkbox: {
        width: '17px',
        height: '17px',
        border: `1px solid ${theme.palette.grey4}`,
        padding: '0',
        borderRadius: '3px',
        margin: '0 12px 0 0',
    },
    CheckboxChecked: {
        padding: '0',
        margin: '0 12px 0 0',
        color: theme.palette.grey4,
        border: `1px solid ${(theme.palette?.common?.white || '#fff')}`,
    },
    checkboxLabel: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '13px',
        fontWeight: '600',
        color: theme.palette.black,
        position: 'relative',
    },
    checkbox: {
        width: '14px',
        height: '14px',
        border: `1px solid ${theme.palette.grey4}`,
        padding: '0',
        borderRadius: '3px',
        margin: '10px',
    },
    checkboxChecked: {
        paddingTop: '4px',
        color: theme.palette.grey4,
        border: '1px solid #fff',
    },
    [theme.breakpoints?.only('xs')]: {
        GMRadioLabel: {
            display: 'inline',
        },
        buttonContainer: {
            margin: '10px 0',
            padding: '0 14px',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '5%',
        },
    },
    giftMessageContainer: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        boxSizing: 'border-box',
        '@media screen and (min-width: 601px)': {
            flexWrap: 'nowrap',
        },
    },
    [theme.breakpoints?.up('sm')]: {
        buttonContainer: {
            margin: 'auto',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '5%',
            '@media screen and (min-width: 768px)': {
                width: '75%',
            },
            '@media screen and (min-width: 1024px)': {
                width: '100%',
            },
        },
        GMRadioLabel: {
            fontSize: '14px',
        },
        giftMessageContainer: {
            marginBottom: '20px',
            '& > div': {
                padding: '15px',
            },
        },
        contPadding: {
            '& p': {
                fontSize: '13px',
                fontWeight: 600,
            },
        },
        giftMessageCharater: {
            display: 'block',
            marginTop: '5px',
        },
        overflowstyle: {
            height: '100%',
            overflow: 'hidden',
        },
    },
    [theme.breakpoints?.up('md')]: {
        giftMessageContainer: {
            '& > div': {
                '&:not(:last-child)': {
                    borderRight: `1px solid ${(theme.palette?.crBgColor || '#dddddd')}`,
                },
            },
        },
    },
    secondaryButtonStyle: {
        backgroundColor: 'transparent',
        color: theme.palette.black,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 16px',
        borderRadius: '30px',
        border: `1px solid ${theme.palette.black}`,
        boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
        width: 'calc(100% - 10px)',
        '&:hover': {
            color: theme.palette.white,
            backgroundColor: theme.palette.colorPrimary,
        },
    },
    primaryButtonStyle: {
        color: theme.palette.white,
        backgroundColor: theme.palette.primaryButton,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 16px',
        borderRadius: '30px',
        border: `1px solid ${theme.palette.primaryButton}`,
        boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
        width: 'calc(100% - 10px)',
        '&:hover': {
            backgroundColor: theme.palette.cms?.primary_hover,
        },
    },
    primaryButtonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
});

// NUMBER_OF_GIFT_MESSAGE_LINES includes no of lines of gift message + 1 line for signature
const responseGiftConfig = {
    1012: {
        brandCode: 'CCO',
        SHOW_GIFT_MESSAGE_AS_LINES: 'Y',
        NUMBER_OF_GIFT_MESSAGE_LINES: 5,
        NUMBER_OF_CHARACTERS_PER_LINE: 30,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 24,
    },
    1002: {
        brandCode: 'TPF',
        SHOW_GIFT_MESSAGE_AS_LINES: 'Y',
        NUMBER_OF_GIFT_MESSAGE_LINES: 5,
        NUMBER_OF_CHARACTERS_PER_LINE: 30,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 24,
    },
    1019: {
        brandCode: 'HD',
        SHOW_GIFT_MESSAGE_AS_LINES: 'Y',
        NUMBER_OF_GIFT_MESSAGE_LINES: 4,
        NUMBER_OF_CHARACTERS_PER_LINE: 29,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 24,
    },
    1009: {
        brandCode: '18B',
        SHOW_GIFT_MESSAGE_AS_LINES: 'Y',
        NUMBER_OF_GIFT_MESSAGE_LINES: 4,
        NUMBER_OF_CHARACTERS_PER_LINE: 29,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 24,
    },
    1018: {
        brandCode: 'SY',
        SHOW_GIFT_MESSAGE_AS_LINES: 'Y',
        NUMBER_OF_GIFT_MESSAGE_LINES: 4,
        NUMBER_OF_CHARACTERS_PER_LINE: 29,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 18,
    },
    1020: {
        brandCode: 'WLF',
        SHOW_GIFT_MESSAGE_AS_LINES: 'Y',
        NUMBER_OF_GIFT_MESSAGE_LINES: 4,
        NUMBER_OF_CHARACTERS_PER_LINE: 29,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 18,
    },
    1025: {
        brandCode: 'SCH',
        SHOW_GIFT_MESSAGE_AS_LINES: 'Y',
        NUMBER_OF_GIFT_MESSAGE_LINES: 4,
        NUMBER_OF_CHARACTERS_PER_LINE: 29,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 24,
    },
    1031: {
        brandCode: 'VC',
        SHOW_GIFT_MESSAGE_AS_LINES: 'Y',
        NUMBER_OF_GIFT_MESSAGE_LINES: 4,
        NUMBER_OF_CHARACTERS_PER_LINE: 29,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 18,
    },
    1001: {
        brandCode: '18F',
        SHOW_GIFT_MESSAGE_AS_LINES: 'N',
        NUMBER_OF_GIFT_MESSAGE_LINES: 1,
        NUMBER_OF_CHARACTERS_PER_LINE: 180,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 14,
    },
    1029: {
        brandCode: 'BRY',
        SHOW_GIFT_MESSAGE_AS_LINES: 'N',
        NUMBER_OF_GIFT_MESSAGE_LINES: 1,
        NUMBER_OF_CHARACTERS_PER_LINE: 180,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 14,
    },
    1010: {
        brandCode: 'FB',
        SHOW_GIFT_MESSAGE_AS_LINES: 'N',
        NUMBER_OF_GIFT_MESSAGE_LINES: 1,
        NUMBER_OF_CHARACTERS_PER_LINE: 180,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 14,
    },
    1034: {
        brandCode: 'FL',
        SHOW_GIFT_MESSAGE_AS_LINES: 'N',
        NUMBER_OF_GIFT_MESSAGE_LINES: 1,
        NUMBER_OF_CHARACTERS_PER_LINE: 180,
        NUMBER_OF_CHARACTERS_OF_SIGNATURE: 14,
    },
};

class SubscriptionGiftForm extends Component {
    constructor(props) {
        super(props);
        const { selectedSubscription } = this.props;
        let subscriptionBrand = selectedSubscription?.brand || '';
        // For floral brands 18F, FB, BRY and GPT product, it has to be as HD
        if (['1001', '1010', '1029'].includes(selectedSubscription?.brand) && selectedSubscription?.recipient?.[0]?.productType === 'GPT') subscriptionBrand = '1019';
        const giftConfig = responseGiftConfig[subscriptionBrand] || {};
        this.gifMessageMultiLine = giftConfig.SHOW_GIFT_MESSAGE_AS_LINES || 'Y';
        this.giftMessageNoOfLines = giftConfig.NUMBER_OF_GIFT_MESSAGE_LINES || 4;             // ---> it includes no of lines of message and signature line
        this.giftMessageCharPerLine = giftConfig.NUMBER_OF_CHARACTERS_PER_LINE || 30;
        this.signatureMaxChars = giftConfig.NUMBER_OF_CHARACTERS_OF_SIGNATURE || 24;
        if (this.gifMessageMultiLine === 'Y') {
            this.giftMessageMaxLimit = (this.giftMessageNoOfLines * this.giftMessageCharPerLine) - this.giftMessageCharPerLine + this.signatureMaxChars;
        } else {
            this.giftMessageMaxLimit = this.giftMessageNoOfLines * this.giftMessageCharPerLine;
        }
        this.state = {
            radioSelection: 'yes',
            hasGiftMessage: false,
            suggestedMessage: [],
            giftMessageLength: this.giftMessageMaxLimit,
            form: {
                giftMessage: {
                    value: '',
                    required: true,
                    alert: false,
                    autoFill: false,
                },
            },
            disableSave: true,
        };
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        this.handleSubmit();
    }

    handleSubmit = () => {
        const {
            ruleId, closeForm, getAuthor, updateGiftMessage, trackEvent,
        } = this.props;
        trackEvent({
            eventCategory: 'Subscriptions Management Portal',
            eventAction: 'click – Edit Card Message Modal',
            eventLabel: 'Save',
        });
        const { form } = this.state;
        const setAuthorOnSubmit = (this.gifMessageMultiLine === 'Y' && getAuthor);

        let giftMessage = form.giftMessage.value;
        const lastPipeIndex = giftMessage.lastIndexOf('|');                                                       // save index before FROM field
        giftMessage = giftMessage.split('|').join(' ');                                                           // remove pipes
        const giftText = giftMessage.substring(0, lastPipeIndex).trim();
        const author = giftMessage.substring(lastPipeIndex).trim();
        giftMessage = `${giftText} ${author && `FROM: ${author}`}`; // join message
        giftMessage = giftMessage.replace(/\s+/g, ' ').trim();                                                    // remove extra spaces
        if (giftMessage === 'FROM: No Card Message') giftMessage = '';
        // closeForm();
        const giftMsgObject = {
            ruleId,
            giftMessage,
            closeForm,
            getAuthor: setAuthorOnSubmit,
        };
        updateGiftMessage(giftMsgObject);
    }

    handleChangeRadio = (event) => {
        const updateState = { ...this.state };
        const targetValue = event?.target?.value;
        switch (targetValue) {
            case 'yes':
                updateState.disableSave = true;
                updateState.form.giftMessage.value = '';
                break;
            case 'no':
                updateState.disableSave = false;
                updateState.form.giftMessage.value = 'No Card Message';
                break;
            default:
                updateState.disableSave = true;
                break;
        }
        updateState.radioSelection = targetValue;
        updateState.form.giftMessage.alert = false;
        updateState.form.giftMessage.autoFill = false;
        updateState.giftMessageLength = this.giftMessageMaxLimit;
        this.setState(updateState);
    };

    isInputFilled = (key, flag) => {
        const updateVal = { ...this.state };
        updateVal.form[key].alert = flag;

        this.setState(() => ({
            form: {
                ...updateVal.form,
            },
        }), () => {
            this.handleFormChanges();
        });
    }

    handleFormChanges = () => {
        const { form, radioSelection } = this.state;
        const FormFieldAlert = Object.keys(form).map((key) => {
            const formDetails = form[key];
            const mandate = form.required;
            const { alert } = formDetails;
            const fieldValue = (form[key].value === 'No Card Message');
            if (radioSelection === 'no') {
                return false;
            }
            if (alert || (mandate && fieldValue)) {
                return true;
            }
            return false;
        });
        if (FormFieldAlert.indexOf(true) >= 0) {
            this.setState({
                disableSave: true,
            });
        } else {
            this.setState({
                disableSave: false,
            });
        }
    }

    handleChangeGiftMessageText = (data) => {
        const updateState = { ...this.state };
        updateState.form.giftMessage.value = data.value;
        updateState.form.giftMessage.autoFill = false;
        updateState.giftMessageLength = data.messageLen;
        this.setState(updateState);
    };

    renderTextArea = () => {
        const {
            getAuthor,
            getYourMessage,
            giftMessageText,
        } = this.props;
        const { form } = this.state;
        let updateGiftMesssageValue = giftMessageText;
        // dynamically adding pipeline as per brand
        const pipeLine = '|'.repeat(this.giftMessageNoOfLines - 1);

        if (giftMessageText.includes('FROM:')) updateGiftMesssageValue = giftMessageText.replace('FROM:', `${pipeLine}From:`);
        else if (giftMessageText.includes('From:')) updateGiftMesssageValue = giftMessageText.replace('From:', `${pipeLine}From:`);
        else if (giftMessageText.includes('-')) {
            const index = giftMessageText.lastIndexOf('-');
            const giftMsgStart = giftMessageText.substring(0, index);
            const giftMsgSignature = giftMessageText.match(/([^-]+$)/)[0];
            updateGiftMesssageValue = `${giftMsgStart} ${pipeLine}From: ${giftMsgSignature}`;
        }

        if (this.gifMessageMultiLine === 'Y') {
            return (
                <GiftMessageMultiTextBox
                    savedGiftMessage={updateGiftMesssageValue}
                    isMultiLines={this.gifMessageMultiLine}
                    noOfLines={this.giftMessageNoOfLines}
                    charPerLine={this.giftMessageCharPerLine}
                    value={form.giftMessage.value}
                    maxNoOfChar={this.giftMessageMaxLimit}
                    signatureMaxChars={this.signatureMaxChars}
                    handleChangeGiftMessageText={this.handleChangeGiftMessageText}
                    isInputFilled={this.isInputFilled}
                    getAuthor={getAuthor}
                    getYourMessage={getYourMessage}
                />
            );
        }

        if (this.gifMessageMultiLine === 'N') updateGiftMesssageValue = updateGiftMesssageValue.replace('|||', '');
        if (this.gifMessageMultiLine === 'N') {
            return (
                <GiftMessageTextBox
                    savedGiftMessage={updateGiftMesssageValue}
                    value={form.giftMessage.value}
                    maxNoOfChar={this.giftMessageMaxLimit}
                    signatureMaxChars={this.signatureMaxChars}
                    handleChangeGiftMessageText={this.handleChangeGiftMessageText}
                    isInputFilled={this.isInputFilled}
                />
            );
        }

        return null;
    }

    render() {
        const { classes, closeForm } = this.props;
        const { radioSelection, giftMessageLength } = this.state;

        const submitGiftMessageUpdate = () => {
            closeForm(true);
        };

        return (
            <Card className={classes.scrollStyle} elevation={0}>
                <Grid container className={classes.cardHeaderWrap}>
                    <Grid item xs={10}>
                        <Typography component="span">
                            <CardHeader
                                data-test="checkout-recipient-header"
                                title="RECIPIENT GIFT MESSAGE"
                                classes={{
                                    root: classes.cardHeaderRoot,
                                    title: classes.cardHeaderTitle,
                                }}
                            />
                        </Typography>
                    </Grid>
                    <Grid container item xs={2} justify="flex-end">
                        <IconButton
                            aria-label="delete"
                            align="right"
                            data-test="checkout-recipient-form-close"
                            data-testid="checkout-recipient-form-close"
                            id="recipientFormCloseLink"
                            onClick={submitGiftMessageUpdate}
                            onKeyPress={submitGiftMessageUpdate}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
                <form onSubmit={this.onFormSubmit}>
                    <div className={classes.overflowstyle}>
                        <CardContent
                            classes={{
                                root: classes.cardContentPadding,
                            }}
                        >
                            <Grid className={classes.giftMessageContainer}>
                                <Grid item sm={12} xs={12} md={6} data-test="subscription-gift-message-form-radio-yes">
                                    <RadioButton
                                        id="subscriptionGiftMessage"
                                        checked={radioSelection === 'yes'}
                                        onChange={this.handleChangeRadio}
                                        value="yes"
                                        name="radio-yes"
                                        data-test="subscription-gift-message-form-radio-yes"    // do NOT change or remove data-test attribute
                                    />
                                    <InputLabel htmlFor="subscriptionGiftMessage" className={classes.GMRadioLabel}>Complimentary Gift Message</InputLabel>
                                    {radioSelection === 'yes' && (
                                        <div className={classes.contPadding}>
                                            <Typography variant="caption">
                                                <i>Include your name so the recipient knows who sent the gift</i>
                                            </Typography>
                                            {this.renderTextArea(classes)}
                                            <Typography variant="caption" className={classes.giftMessageCharater}>
                                                {giftMessageLength} characters left
                                            </Typography>
                                        </div>
                                    )}
                                </Grid>
                                <Grid item sm={12} xs={12} md={6} data-test="subscription-gift-message-form-radio-no">
                                    <Grid>
                                        <Grid item sm={12} md={12}>
                                            <RadioButton
                                                id="noSubscriptionGiftMessage"
                                                checked={radioSelection === 'no'}
                                                onChange={this.handleChangeRadio}
                                                value="no"
                                                name="radio-no"
                                                classes={{ root: classes.giftMessageRadio, checked: classes.giftMsgChecked }}
                                                data-test="subscription-gift-message-form-radio-no"     // do NOT change or remove data-test attribute
                                            />
                                            <InputLabel
                                                htmlFor="noSubscriptionGiftMessage"
                                                className={classes.GMRadioLabel}
                                                data-test="subscription-gift-message-form-radio-no-label" // do NOT change or remove data-test attribute
                                            >
                                                No Gift Message
                                            </InputLabel>
                                        </Grid>
                                        <Grid item sm={12} md={12} className={classes.contPadding}>
                                            <Typography variant="body2">
                                                If you do not include a gift message, the recipient won&apos;t know who sent this gift.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                        {/* ACTION BUTTONS */}
                        <Grid item xs={12} className={classes.buttonContainer}>
                            <Grid item xs={6} sm={12} md={3}>
                                <Button onClick={submitGiftMessageUpdate} fullWidth className={classes.secondaryButtonStyle}>Cancel</Button>
                            </Grid>
                            <Grid className={classes.primaryButtonContainer} item xs={6} sm={12} md={3}>
                                <Button fullWidth type="submit" className={classes.primaryButtonStyle}>Save</Button>
                            </Grid>
                        </Grid>
                    </div>
                </form>
            </Card>
        );
    }
}

SubscriptionGiftForm.propTypes = {
    ruleId: PropTypes.string.isRequired,
    closeForm: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    giftMessageText: PropTypes.string.isRequired,
    getAuthor: PropTypes.bool,
    getYourMessage: PropTypes.bool,
    updateGiftMessage: func.isRequired,
    selectedSubscription: object.isRequired,
    trackEvent: func.isRequired,
};

SubscriptionGiftForm.defaultProps = {
    getAuthor: false,
    getYourMessage: false,
};
const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
    updateGiftMessage: (data) => dispatch(EventDispatcher.updateSubscriptionGiftMessage(data)),
});

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    withRouter,
    withStyles(styles),
);

export default enhance(SubscriptionGiftForm);
